/**
 * TextField — a single-line `text` attribute (PIM Wave P2, Task 3). The
 * form-schema DTO carries no multiline flag (mirrors the admin `FormPreview`),
 * so every `text` field is one line.
 */
import type { ReactElement } from "react";

import {
  pickOptionalText,
  pickText,
} from "@/features/seller-dashboard/attributes/formSchema";
import {
  ATTR_INPUT_CLASS,
  ATTR_INPUT_ERROR_CLASS,
  FieldShell,
  type AttributeFieldProps,
} from "@/features/seller-dashboard/attributes/fields/FieldShell";

export function TextField({
  field,
  language,
  value,
  onChange,
  onBlur,
  error,
  disabled,
}: AttributeFieldProps): ReactElement {
  const label = pickText(field.label, language);
  const hint = pickOptionalText(field.hint, language);
  const example = pickOptionalText(field.example, language);
  const controlId = `attr-${field.field_slug}`;
  return (
    <FieldShell
      slug={field.field_slug}
      label={label}
      requirement={field.requirement}
      hint={hint}
      error={error}
    >
      <input
        id={controlId}
        type="text"
        aria-label={label}
        aria-invalid={error ? true : undefined}
        placeholder={example}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        className={[ATTR_INPUT_CLASS, error ? ATTR_INPUT_ERROR_CLASS : ""].join(" ")}
      />
    </FieldShell>
  );
}

export default TextField;
